import { useMsal } from "@azure/msal-react";
import { Box, Heading, Image, Markdown, ResponsiveContext } from "grommet";
import * as React from "react";
import KnowledgeCheck from "./KnowledgeCheck";
import AsteroidsGame from "../components/AsterioidsGame";
import { useDarkMode } from "../components/DarkModeSwitch";
import ProcessGraph from "../components/ProcessGraph";
import { CONTEXTCLAIMTYPE, useUser } from "../utils/AccountStore";
import { RulesText } from "../utils/LocalizationStore";

let Home = () => {
    const [isDarkMode, toggleDarkMode] = useDarkMode();

    const [metadata, setMetdata] = React.useState({ showCertificates: true, showDownloads: false } as { showCertificates: boolean; showDownloads: boolean });
    let [loading, setLoading] = React.useState(true);
    const [showGuides, setShowGuides] = React.useState(false);

    const { instance } = useMsal();

    let { user, setUser } = useUser();

    React.useEffect(() => {
        if (user.isAuthenticated) {
            let context = user.claims.filter((c) => c.type == CONTEXTCLAIMTYPE)[0].value;
            if (context) {
                let tasks = [] as any[];

                // tasks.push({ id: "registerOrganization", name: "Register your school", complete: false });

                if (tasks.every((t) => t.complete)) {
                    tasks = [];
                }

                setTasks(tasks);
            }

            setLoading(false);
        }
    }, [user]);

    const [tasks, setTasks] = React.useState([] as any[]);

    const maxSize = screen?.width > 800 ? "250px" : "100%";
    const logoMaxSize = screen?.width > 600 ? "400px" : "75%";
    const brandMaxSize = screen?.width > 600 ? "300px" : "75%";

    const size = React.useContext(ResponsiveContext);

    const [gridAreas, setGridAreas] = React.useState([] as any[]);
    const [columns, setColumns] = React.useState([] as any[]);

    React.useEffect(() => {
        if (size == "small") {
            setGridAreas([
                { name: "header", start: [0, 0], end: [0, 0] },
                { name: "main", start: [0, 1], end: [0, 1] },
            ]);
            setColumns(["auto"]);
        } else {
            setGridAreas([
                { name: "header", start: [0, 0], end: [1, 0] },
                { name: "main", start: [0, 1], end: [0, 1] },
                { name: "ad", start: [1, 1], end: [1, 1] },
            ]);
            setColumns(["auto", "1/4"]);
        }
    }, [size]);

    return (
        <div>
            <AsteroidsGame style={{ opacity: 0.1 }}></AsteroidsGame>
            {user && (
                <Box align="center">
                    <Image margin="small" alignSelf="center" fit="contain" src={"/images/logo2.png"} width={logoMaxSize} />
                    <Heading level={2} margin="small">
                        Code the Climate Hackathon
                    </Heading>

                    <Box style={{ position: "relative" }}>
                        <KnowledgeCheck onChange={() => {}}></KnowledgeCheck>
                        <Box direction={size != "small" ? "row" : "column"} gap="small" align="center">
                            <Box>
                                <Markdown>{RulesText}</Markdown>
                                <Image margin="small" alignSelf="center" fit="contain" src={"/images/unisa_hack.png"} width={brandMaxSize} />
                            </Box>
                            <ProcessGraph></ProcessGraph>
                        </Box>
                        {size != "small" && (
                            <Box style={{ position: "absolute", right: "100%" }}>
                                <Image margin="small" alignSelf="center" fit="contain" src="/images/robot2.png" width={maxSize} />
                            </Box>
                        )}
                    </Box>
                </Box>
            )}
        </div>
    );
};

export default Home;
